import { useParams } from 'react-router-dom';
import { gql, useMutation } from '@apollo/client';
import { useQueryWithMsg } from '../../utils/hooks';
import UserForm from './UserForm';
import FormContainer from '../FormContainer';
import { CurrentUserQuery, UsersQuery } from '../../queries';
import { useSetBreadcrumbEffect } from '../../contexts/BreadcrumbContext';

const UserQuery = gql`
  query getUser($id: ID!) {
    user(id: $id) {
      id
      updatedAt
      email
      firstName
      lastName
      superadminRole
      defaultUnitSystem
    }
  }
`;

const UPDATE_USER_MUTATION = gql`
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      result {
        email
      }
      errors
    }
  }
`;

const EditUser = ({ user, showBreadcrumbs }) => {
  const { id } = useParams();
  const { msg, data: queryData } = useQueryWithMsg(UserQuery, {
    variables: { id },
    skip: !id,
  });

  const [mutation] = useMutation(UPDATE_USER_MUTATION, {
    refetchQueries: [{ query: id ? UsersQuery : CurrentUserQuery }],
    onCompleted: (response) => {
      const responseObject = Object.values(response)[0];
      if (responseObject.errors) {
        console.error(responseObject.errors);
      }
    },
    onError: (e) => console.error(e),
  });

  const existingUser = user || queryData?.user;

  const initialValues = {
    ...(existingUser || []),
    firstName: existingUser?.firstName || '',
    lastName: existingUser?.lastName || '',
  };

  useSetBreadcrumbEffect(
    showBreadcrumbs ? [{ display: msg || existingUser?.email }] : null,
    [showBreadcrumbs, msg, existingUser],
  );

  return (
    <FormContainer className="mt-3">
      <h2>Update user settings</h2>
      {msg || (
        <UserForm
          mutation={mutation}
          showLabels
          initialValues={initialValues}
          submitButtonText="Save"
          successMessage="User settings updated"
          showSuperadmin={!!id}
        />
      )}
    </FormContainer>
  );
};

export default EditUser;
